import { HomeComponent } from './home.component';
export default HomeComponent;


// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/home/index.ts